const BarreBottom = () => {
    return (
        <div style={{ width: "100%", borderTop: "5px solid #14356a", marginTop: "20px" }}></div>
    )
}

export default BarreBottom;